import { DiffState, Product } from '../../hooks/use-product-cart';

export const calcCartSummary = (diff: DiffState) => {
  let totalQuantity = 0;
  let totalAmount = 0;
  let totalWeight = 0;

  diff.forEach(({ type, product }) => {
    let delta = 0;

    if (type === 'create') {
      delta = product.newQuantity;
    }

    if (type === 'update') {
      delta = product.newQuantity - product.originQuantity;
    }

    if (type === 'remove') {
      delta = -product.originQuantity;
    }

    totalQuantity += delta;
    totalAmount += delta * product.currentPriceAmount;
    totalWeight += delta * product.weight;
  });

  return {
    totalQuantity,
    totalAmount,
    totalWeight,
  };
};

export const splitDiffByType = (diff: DiffState) => {
  const create: Product[] = [];
  const update: Product[] = [];
  const remove: Product[] = [];

  diff.forEach((item) => {
    if (item.type === 'create') create.push(item.product);
    else if (item.type === 'update') update.push(item.product);
    else if (item.type === 'remove') remove.push(item.product);
  });

  return {
    create,
    update,
    remove,
  };
};
